<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="newcontroller">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          class="mx-5"
        >
          <div class="display-1 font-weight-medium mb-3">
            {{ $t('dodaj-sterownik') }}
          </div>
          <div class="font-weight-light mb-6 c-lighter-1">
            {{ $t('new-ster-info') }}
          </div>
        
          <v-text-field
          v-model="controllerId"
          :rules="controllerIdRules"
          :label="$t('id-sterownika')"
          :counter="16"
          required
          ></v-text-field>

          <v-text-field
          v-model="displayName"
          :rules="displayNameRules"
          :label="$t('display-name')"
          required
          ></v-text-field>
          
          <div class="text-center mt-8">
            <v-btn 
            :loading="saving"
            :disabled="saving" 
            @click="postForm"
            x-large class="w-100" color="primary">{{ $t('dodaj-sterownik') }}</v-btn>
          </div>
          <div class="text-center mt-2">
            <v-btn x-large text class="w-100" @click="back">{{ $t('anuluj') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data: () => ({
    valid: true,
    controllerId: null,
    controllerIdRules: [
      v => !!v || 'Wypełnij Id sterownika',
      v => (v && v.length >= 16) || 'Za krótki Id sterownika (16 znaków)',
      v => (v && v.length <= 16) || 'Za długi Id sterownika (16 znaków)'
    ],
    displayName: '',
    displayNameRules: [
      v => !!v || 'Podaj własną nazwę sterownika',
      v => (v && v.length > 2 && v.length <26) || 'Nazwa sterownika musi mieć od 3 do 25 znaków'
    ],
    saving: false,
    success: false
  }),
  computed: {
    ...mapGetters([
      'token'
    ])
  },
  methods: {
    ...mapActions([
      'addController',
      'syncControllers'
    ]),
    postForm () {
      this.saving = true;
      
      const formData = new URLSearchParams();
      formData.append('controllerId', this.controllerId);
      formData.append('displayName', this.displayName);
      formData.append('token', this.token);

      this.addController(formData)
      .then(res => {
        if (res.error) {
          this.saving = false;
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } else {
          this.syncControllers(true).then(res => {
            this.saving = false;
            this.$router.push({ path: '/controllers' });
          })
        }
      });
    },
    back() {
      this.$router.push({ path: '/controllers' });
    }
  },
  created () {
    // console.log(this.$i18n.t(22));
  }
}
</script>

<style>
</style>

